export default __webpack_public_path__ + "static/media/Gloves of Crimson Slaughter (nm).3fd76198.jpg";